import { render, staticRenderFns } from "./zuheShangpin_do.vue?vue&type=template&id=0342662e&scoped=true"
import script from "./zuheShangpin_do.vue?vue&type=script&lang=js"
export * from "./zuheShangpin_do.vue?vue&type=script&lang=js"
import style0 from "./zuheShangpin_do.vue?vue&type=style&index=0&id=0342662e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0342662e",
  null
  
)

export default component.exports